module.exports = __webpack_public_path__ + "media/images/clearangel-invert-6b381263257c937ff22ca09a7635f67b.svg";